import api from "../axios";

/*
|--------------------------------------------------------------------------
| LIST OFFERS
|--------------------------------------------------------------------------
*/

export const getOffers = async (params = {}) => {
  const response = await api.get("/offers", {
    params
  });

  return response.data;
};


/*
|--------------------------------------------------------------------------
| GET OFFER
|--------------------------------------------------------------------------
*/

export const getOffer = async (id) => {
  const response = await api.get(
    `/offers/${id}`
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| CREATE OFFER
|--------------------------------------------------------------------------
*/

export const createOffer = async (data) => {
  const response = await api.post(
    "/offers",
    data
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| UPDATE OFFER
|--------------------------------------------------------------------------
*/

export const updateOffer = async (
  id,
  data
) => {
  const response = await api.patch(
    `/offers/${id}`,
    data
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| CHANGE STATUS
|--------------------------------------------------------------------------
*/

export const changeOfferStatus = async (
  id,
  status
) => {
  const response = await api.patch(
    `/offers/${id}/status`,
    {
      status
    }
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| DELETE OFFER
|--------------------------------------------------------------------------
*/

export const deleteOffer = async (id) => {
  const response = await api.delete(
    `/offers/${id}`
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| ADD ITEM
|--------------------------------------------------------------------------
*/

export const addOfferItem = async (
  offerId,
  data
) => {
  const response = await api.post(
    `/offers/${offerId}/items`,
    data
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| UPDATE ITEM
|--------------------------------------------------------------------------
*/

export const updateOfferItem = async (
  offerId,
  itemId,
  data
) => {
  const response = await api.patch(
    `/offers/${offerId}/items/${itemId}`,
    data
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| DELETE ITEM
|--------------------------------------------------------------------------
*/

export const deleteOfferItem = async (
  offerId,
  itemId
) => {
  const response = await api.delete(
    `/offers/${offerId}/items/${itemId}`
  );

  return response.data;
};